import { BlankPageFactory } from "./stdlib-blankpage";

const NotFoundPage = BlankPageFactory({ pageTitle: "Not Found", pageMessage: "This page does not exist. Choose a page from the menu" });

export default NotFoundPage;